import { Injectable, signal } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    // Signal replaces the previous `loader$` BehaviorSubject.
    public readonly loader = signal(false);

    showLoader() {
        this.loader.set(true);
    }

    hideLoader() {
        this.loader.set(false);
    }
}
